import { useCallback } from 'react';

const getKey = (menuId: string) => {
    return `__${menuId}_routeData__`;
};

/**
 * 메뉴 routeData 스토리지 저장/획득 처리 hook 함수
 */
const useRouteDataStorage = () => {
    /**
     * routeData를 로컬스토리지에 저장한다.
     */
    const set = useCallback(<T extends unknown>(menuId: string, data: T) => {
        try {
            const key = getKey(menuId);
            const json = JSON.stringify(data);
            const encoded = btoa(String.fromCharCode(...new TextEncoder().encode(json)));
            localStorage.setItem(key, encoded);
        } catch (e) {
            console.error('[useRouteDataStorage:set] 실패', e);
        }
    }, []);

    /**
     * routeData를 로컬스토리지에 저장한다.
     */
    const get = useCallback(<T extends any>(menuId: string) => {
        try {
            const key = getKey(menuId);
            const stored = localStorage.getItem(key);
            if (!stored) {
                return {} as T;
            }

            const decoded = new TextDecoder().decode(
                Uint8Array.from(atob(stored), (c) => c.charCodeAt(0)),
            );

            return JSON.parse(decoded) as T;
        } catch (e) {
            console.error('[useRouteDataStorage:get] 실패', e);
        }
    }, []);

    /**
     * 로컬스토리이지에서 삭제
     */
    const remove = useCallback((menuId: string) => {
        const key = getKey(menuId);
        localStorage.removeItem(key);
    }, []);

    return {
        set,
        get,
        remove,
    };
};

export { useRouteDataStorage };
